module.exports = __webpack_public_path__ + "static/img/img_home_iot.3ae7bac4.png";